import * as React from "react";

const IconPerfil = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <ellipse
      cx="23.879"
      cy="23.789"
      fill="var(--color-lstmenu-fundo)"
      rx="23.879"
      ry="23.789"
    ></ellipse>
    <path
      fill="var(--color-01)"
      d="M12.508 36.363s-2.274 0-2.274-2.124 2.274-8.496 13.645-8.496 13.645 6.372 13.645 8.496-2.274 2.124-2.274 2.124zM23.88 23.618c1.81 0 3.545-.672 4.824-1.867 1.28-1.195 1.999-2.815 1.999-4.505s-.72-3.31-1.999-4.506c-1.28-1.195-3.014-1.866-4.824-1.866s-3.545.671-4.824 1.866c-1.28 1.195-1.998 2.816-1.998 4.506s.718 3.31 1.998 4.505 3.015 1.867 4.824 1.867"
    ></path>
  </svg>
);

export default IconPerfil;
